<ng-container *transloco="let t;">
  <app-list-view [title]="title" [messages]="messages" [loading]="loading">

    <div buttons>
      <button withRight="admin.ac.list" pButton (click)="onReload()" type="button" icon="pi pi-refresh" class="p-button-secondary p-button-outlined p-mb-2" aria-label="{{ t('common.labels.reload_list') }}" pTooltip="{{ t('common.labels.reload_list') }}" tooltipPosition="left"></button>
      <button withRight="admin.ac.create" *ngIf="mode === 'planned'" pButton (click)="onNew()" type="button" icon="pi pi-plus" label="{{ t('common.labels.new') }}" class="p-button-success p-ml-2 p-mb-2"></button>
    </div>

    <div table>
      <p-table
        [value]="acs"
        [paginator]="true"
        [rows]="20"
        stateStorage="local"
        stateKey="ac-list"
        [rowsPerPageOptions]="rowsPerPage"
        [showCurrentPageReport]="true"
        [currentPageReportTemplate]="t('common.labels.current_page_report')"
        #dt
      >
        <ng-template pTemplate="header">
            <tr>
              <th style="width:30px" *ngIf="mode === 'planned'"></th>
              <th pSortableColumn="name">{{ t('common.labels.name') }}
                  <p-sortIcon field="name"></p-sortIcon>
              </th>
              <th pSortableColumn="candidate_names">{{ t('common.labels.candidates') }}
                  <p-sortIcon field="candidate_names"></p-sortIcon>
              </th>
              <th pSortableColumn="start_time">{{ t('common.labels.date') + getDstLabel() }}
                  <p-sortIcon field="start_time"></p-sortIcon>
              </th>
              <th withFeature="customers" pSortableColumn="customer_name">{{ t('common.labels.customer') }}
                  <p-sortIcon field="customer_name"></p-sortIcon>
              </th>
              <th pSortableColumn="dispatcher_name">{{ t('common.labels.dispatcher') }}
                  <p-sortIcon field="dispatcher_name"></p-sortIcon>
              </th>
            </tr>
            <tr class="filter">
              <th *ngIf="mode === 'planned'"></th>
              <th>
                <p-columnFilter type="text" field="name" [matchMode]="'contains'"></p-columnFilter>
              </th>
              <th>
                <p-columnFilter type="text" field="candidate_names" [matchMode]="'contains'"></p-columnFilter>
              </th>
              <th>
                <p-columnFilter type="date" field="start_time_as_date" [showMatchModes]="true" [showOperator]="false" [showAddButton]="false">
                  <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                    <p-calendar #calendar [ngModel]="value" (onSelect)="filter(calendar.value)" (onInput)="setup(calendar.value, 'start_time_as_date')" dateFormat="dd.mm.yy"></p-calendar>
                  </ng-template>
                </p-columnFilter>
              </th>
              <th withFeature="customers">
                <p-columnFilter type="text" field="customer_name" [matchMode]="'contains'"></p-columnFilter>
              </th>
              <th>
                <p-columnFilter type="text" field="dispatcher_name" [matchMode]="'contains'"></p-columnFilter>
              </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-ac>
            <tr (click)="onOpen(ac)" (keyup.enter)="onOpen(ac)" hoverOnRight="admin.ac.show" tabindex="0">
              <td *ngIf="mode === 'planned'">
                <fa-icon *ngIf="ac.invitationSended()" [icon]="faEnvelope" class="p-mr-2" pTooltip="{{ t('ac_list.ac_ready') }}"></fa-icon>
              </td>
              <td><span role="link">{{ ac.name }}</span></td>
              <td [innerHTML]="ac.candidate_names | replace : ', ' : '&lt;br&gt;'"></td>
              <td><span *ngIf="ac.start_time_admin !== null">{{ac.start_time_admin | amLocal | amDateFormat: 'DD.MM.YYYY  - HH:mm'}} {{ t('common.labels.oclock') }}</span></td>
              <td withFeature="customers">{{ ac.customer_name }}</td>
              <td>{{ ac.dispatcher_name }}</td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td class="no-data" [attr.colspan]="mode === 'planned' ? 5 : 4">{{ t('common.labels.no_data') }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>

  </app-list-view>
</ng-container>
